import DocumentFormatPattern from '@/domain/models/document-format-pattern-model'

const SIZE_MESSAGE = 'O documento exige exatos 18 caracteres neste campo'

const CurpDocumentFormatPattern: DocumentFormatPattern<RegExp> = {
  normalize: (value: string) => value.trim().toUpperCase(),
  mask: /^[\w|.-]{0,18}$/,
  prepareChar: str => str.toUpperCase(),
  placeholder: 'XXXX000000XXXXXX00',
  blocks: {},
  validate: (value?: string): boolean => {
    if (!value || value.length < 18) return false
    return /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/.test(
      value
    )
  },
  isValid: (value?: string): boolean => {
    return CurpDocumentFormatPattern.validate?.(value) === true
  },
  rules: {
    minLength: {
      value: 18,
      message: SIZE_MESSAGE
    },
    maxLength: {
      value: 18,
      message: SIZE_MESSAGE
    }
  }
}
export default CurpDocumentFormatPattern
